require("!!/home/hellomojito/agency-space/node_modules/script-loader/addScript.js")(require("!!/home/hellomojito/agency-space/node_modules/raw-loader/index.js!/home/hellomojito/agency-space/assets/plugins/select2/js/select2.js"))


//////////////////
// WEBPACK FOOTER
// ./assets/plugins/select2/js/select2.js
// module id = 154
// module chunks = 0